import React, { useContext } from 'react';
import _isEmpty from 'lodash/isEmpty';

import { Card } from 'components/Card';
import Roster from 'components/Roster';
import { bem } from 'helpers/class-name';

import ServicesContext from '../ServicesContext';
import EmptyList from '../../EmptyList';
import messages from '../../ManageServices.messages';
import ServicesListItem from './ServicesListItemContainer';

const { block } = bem('services-list');
const blockClasses = block('mb-0');

function ServicesList() {
  const { servicesWithPrice, isLoading } = useContext(ServicesContext);

  if (isLoading || _isEmpty(servicesWithPrice)) {
    return (
      <Card className={blockClasses} loading={isLoading} centered>
        <EmptyList
          header={messages.empty.servicesHeader}
          text={messages.empty.servicesText}
          button={messages.addBtn.service}
        />
      </Card>
    );
  }

  return (
    <>
      <Roster
        data={servicesWithPrice}
        RowComponent={ServicesListItem}
        getKey={({ id }) => id}
        className={blockClasses}
      />
    </>
  );
}

export default ServicesList;
